import { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import { Toolbar } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
//import HeaderMainPublicBlack from '../../components/Header/HeaderMainPublicBlack'
import HeaderMainPublic from '../Header/HeaderMainPublic';
import FooterEnd from '../Footer/FooterEnd';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Fade from '@mui/material/Fade';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
//import { gradientColor_1, gradientColor_2} from '../../colors';



export default function PagePublic({linkgroup, headline, main}) {

return (
<>
    <Container maxWidth={false} sx={{  zIndex: 0, minHeight: '100vH',  }}>

      <Grid container>                         
     
            <Toolbar  id="back-to-top-anchor" />
            <HeaderMainPublic linkgroup= {linkgroup}  />
            
            <Grid size={12}>
                    
            <Box component="main">
              {main}
            </Box>
            
            </Grid>
       </Grid>
  </Container>

  <FooterEnd />
 

<ScrollTop>
    <Fab size="small" aria-label="scroll back to top" sx={{bgcolor: 'background.greenlight', color: 'primary.dark', '&:hover': { color: 'primary.dark'},}}>
      <KeyboardArrowUpIcon />
    </Fab>
</ScrollTop>

 </>
  )
}


/* Helper Function to show button to scroll back to top */

/* Scroll-to-top helper */

function ScrollTop({ children }) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document)
      .querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({ block: 'center' });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 100,
          cursor: 'pointer',
        }}
      >
        {children}
      </Box>
    </Fade>
  );
}